import { useState, useEffect } from 'react';
import { multiversxUrlApi } from 'src/config';
import { handleUnexpectedException } from 'src/helpers/functions';

function useTokenBalance(address, tokenIdentifier) {
    const [tokenBalance, setTokenBalance] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTokenBalance = async () => {
            try {
                const response = await fetch(
                    `${multiversxUrlApi}/accounts/${address}/tokens?identifier=${tokenIdentifier}`
                );
                const data = await response.json();

                if (response.ok) {
                    const token = data.find((t) => t.identifier === tokenIdentifier);

                    if (token) {
                        setTokenBalance(token.balance);
                    } else {
                        setError(`Token with identifier '${tokenIdentifier}' not found for the address.`);
                    }
                } else {
                    handleUnexpectedException(data.message);
                    setError(`Error: ${data.message}`);
                }
            } catch (error) {
                handleUnexpectedException(error);
                setError(`Error: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

        if (address && tokenIdentifier) {
            fetchTokenBalance();
        }
    }, [address, tokenIdentifier]);

    return { tokenBalance, loading, error };
}

export default useTokenBalance;
